import { combineReducers } from 'redux'

import context from '@/components/App/reducer'
import authentication from '@/components/AuthenticationHandler/reducer'
import publisher from '@/components/Publisher/reducer'
import chat from '@/components/Segments/Chat/reducer'
import organizationAuditConnectorPage from '@/pages/OrganizationAuditConnectorPage/reducer'
import organizationAuditPage from '@/pages/OrganizationAuditPage/reducer'
import organizationChannelConnectionsPage from '@/pages/OrganizationChannelConnectionsPage/reducer'
import organizationGroupsMembersPage from '@/pages/OrganizationGroupsMembersPage/reducer'
import organizationGroupsPage from '@/pages/OrganizationGroupsPage/reducer'
import organizationSettingsPage from '@/pages/OrganizationSettingsPage/reducer'
import organizationSpaceEditPage from '@/pages/OrganizationSpaceEditPage/reducer'
import organizationToolbarsPage from '@/pages/OrganizationToolbarsPage/reducer'
import organizationUserAttributes from '@/pages/OrganizationUserAttributesPage/reducer'
import organizationEditUsersPage from '@/pages/OrganizationUserEditPage/reducer'
import organizationUserProvisioningPage from '@/pages/OrganizationUserProvisioningPage/reducer'
import organizationUsersBulkAddPage from '@/pages/OrganizationUsersBulkAddPage/reducer'
import organizationUsersPage from '@/pages/OrganizationUsersPage/reducer'
import spaceAnalyticsPage from '@/pages/SpaceAnalyticsPage/reducer'
import SpaceAppBuilderFeaturesPage from '@/pages/SpaceAppBuilder/FeaturesPage/reducer'
import catalogApp from '@/pages/SpaceCatalogAppDetailsPage/reducer'
import conversationAnalytics from '@/pages/SpaceChatbotAnalyticsPage/reducer'
import dictionary from '@/pages/SpaceChatbotCorporateDictionaryPage/reducer'
import knowledge from '@/pages/SpaceChatbotKnowledgeHubPage/reducer'
import spaceChatbotLogsPage from '@/pages/SpaceChatbotLogsPage/reducer'
import spaceConnectorLogsPage from '@/pages/SpaceConnectorLogsPage/reducer'
import customAppEditPage from '@/pages/SpaceCustomAppEditPage/reducer'
import customAppPage from '@/pages/SpaceCustomAppEditPage/reducer'
import spaceMembersPage from '@/pages/SpaceMembersPage/reducer'
import spaceMembersRolesPage from '@/pages/SpaceMembersRolesPage/reducer'
import spacePublisherLogsPage from '@/pages/SpacePublisherLogsPage/reducer'
import spacePublisherPage from '@/pages/SpacePublisherPage/reducer'

import configuration from './ConfigurationReducer'
import errors from './ErrorReducer'
import request from './RequestReducer'
import roles from './RolesReducer'
import sentry from './SentryReducer'
import spaces from './SpacesReducer'
import users from './UsersReducer'

const rootReducer = combineReducers({
  authentication,
  catalogApp,
  configuration,
  context,
  customAppPage,
  customAppEditPage,
  errors,
  knowledge,
  dictionary,
  chat,
  spaceChatbotLogsPage,
  conversationAnalytics,
  organizationAuditConnectorPage,
  organizationAuditPage,
  organizationEditUsersPage,
  organizationSettingsPage,
  organizationSpaceEditPage,
  organizationGroupsPage,
  organizationGroupsMembersPage,
  organizationUserAttributes,
  organizationUserProvisioningPage,
  organizationUsersPage,
  organizationUsersBulkAddPage,
  organizationToolbarsPage,
  organizationChannelConnectionsPage,
  publisher,
  roles,
  spaceAnalyticsPage,
  spacePublisherPage,
  spaceMembersPage,
  spaceMembersRolesPage,
  spaceConnectorLogsPage,
  spaces,
  users,
  sentry,
  spacePublisherLogsPage,
  SpaceAppBuilderFeaturesPage,
  __meta: request
})

export default rootReducer
